module.exports = __webpack_public_path__ + "static/media/midwifes_old.18aae675.jpg";